import React, { Component } from "react";

class Logout extends Component {
  componentDidMount() {
    const ROOT_URL = process.env.API_ROOT_URL;
    window.location =
      "https://login.realgeeks.com/oauth/logout?next=" +
      ROOT_URL.substr(0, ROOT_URL.length - 3) +
      "/auth/realgeeks/";
  }

  render() {
    return <div />;
  }
}
export default Logout;
